import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isMenuOpen: "ui/isMenuOpen",
      isModalOpen: "ui/isModalOpen",
      modalContent: "ui/modalContent",
    }),
  },
  methods: {
    onModalMenuClick(item) {
      const itemModalContent = item.modalContent;

      if (!this.isModalOpen) {
        this.toggleModal(true);
        this.toggleMenu(false);
      }

      if (this.modalContent !== itemModalContent) {
        this.setModalContent(itemModalContent);
      }
    },
    onExternalMenuClick(item) {
      const url = item.internalPdf ? `${this.$baseUrl}${item.url}` : item.url;
      if (!item.internalPdf) {
        window.digitalData.push({
          event: "click-download",
          pageEvent: {
            eventInfo: {
              eventDetail: "PDF",
              contentTitle: item.url,
              contentURL: item.url,
              ctaLabel: "Download pdf",
            },
          },
        });
      }

      window.open(url, "_blank");
    },
    onRouterMenuClick(item) {
      if (item.text === "Home") {
        this.setMainSource(null);
        this.setIndexFromMenu(-1);
      } else {
        this.setIndexFromMenu(item.landingIndex);
      }
      this.setLink({ path: "/" });
      if (this.isMenuOpen) {
        this.toggleMenu(false);
      }
      if (this.$route.params.name !== "landing")
        this.$router.push({ name: "landing" });
    },
    ...mapActions({
      setLink: "ui/setPreviousLink",
      setMainSource: "ui/setMainSource",
      setIndexFromMenu: "scroller/setIndexFromMenu",
      toggleMenu: "ui/toggleMenu",
      toggleModal: "ui/toggleModal",
      setModalContent: "ui/setModalContent",
    }),
  },
};
